<template>
	<div class="media widthz">
		<div class="navGo flex ">
			<span @click="goHomg()">首页></span>
			<span>更多</span>
		</div>

		<section class="widthWhite">
			<div class="flex zhong float">
				<figure class="flex zhong more_fg">
					<img src="../../image/zs_icona.png" />
					<figcaption>{{newsTitle}}</figcaption>
				</figure>
			</div>
			<article class="home_mei_right">
				<ul class="flex wrap">
					<li class="flex float home_mei_right_li shou" v-for="(item, index) in meiList" :key="index"
						@click="showPop(item)">
						<img :src="item.HeadImgStr" />
						<hgroup>
							<h6>{{ item.Name }}</h6>
							<p class="shlTwo">{{ item.Profit }}</p>
						</hgroup>
					</li>
				</ul>
			</article>
			<article class="flex zhong center page">
				<el-pagination background layout="prev, pager, next" @current-change="GetMore" :current-page="page"
					:page-size="10" :total="totle"></el-pagination>
			</article>
		</section>

		<!-- 弹窗 -->
		<aside class="popup flexCenter" v-if="isPop">
			<div class="bai_boxa">
				<div class="bai_box ">
					<img src="../../image/vol-del-t.png" class="shou" @click="isPop = false" />
					<li class="flex float home_mei_right_li home_mei_right_lia">
						<img :src="dataObj.HeadImgStr" />
						<hgroup style="border-bottom: none;">
							<h6>{{dataObj.Name}}</h6>
							<p>{{ dataObj.Profit }}</p>
						</hgroup>
					</li>
				</div>
			</div>
		</aside>
	</div>
</template>
<script>
	export default {
		name: 'media',
		data() {
			return {
				isPop: false,
				// 专家
				meiList: [],
				page: 1,
				totle: 0,
				newsTitle: '专家预约',
				dataObj: null
			};
		},
		mounted() {
			this.GetList(1);
		},
		methods: {
			showPop(item) {
				this.dataObj = item;
				this.isPop = true
			},
			// 返回首页
			goHomg() {
				this.$router.push('/home');
			},
			// 录播
			luboTo() {
				this.$router.push('/luboxq');
			},
			GetList: function(page) {
				var that = this;
				console.log(that.KeyWord);
				that.$api.HtppRequest(
					'WebsiteSet/GetAppointment?size=10&page=' + page,
					'GET', {},
					function(res) {
						console.log('获取专家预约');
						console.log(res);
						if (res.code === 0) {
							that.meiList = res.data;
							that.page = page;
						}
						that.GetNewsTitle();
					},
					function(res) {}
				);
			},
			GetMore: function(page) {
				var that = this;
				that.page = page;
			},
			// 获取首页开启状态
			GetProjectSet: function() {
				var that = this;
				that.$api.HtppRequest(
					'WebsiteSet/GetProjectSet',
					'GET', {},
					function(res) {
						console.log('获取首页开启状态');
						console.log(res);
						if (res.code === 0) {
							var list = res.data;
							for (var i = 0; i < list.length; i++) {
								if (list[i].type === 3) {
									that.newsTitle = list[i].Name;
								}
							}
						}
					},
					function(res) {}
				);
			}
		}
	};
</script>
<style lang="scss" scoped>
	.home_mei_right_li.home_mei_right_lia:hover {
		opacity: 1;
	}

	.home_mei_right_li.home_mei_right_lia p {
		height: auto;
		-webkit-line-clamp: revert;
	}

	.bai_box>img {
		width: 22px;
		height: 22rpx;
		position: absolute;
		right: 20px;
		top: 20px;
		z-index: 1;
	}

	.bai_box {
		    height: 98%;
		    width: 100%;
		    overflow: auto;
	}

	.bai_boxa {
		width: 690px;
		padding: 20px;
		height: 430px;
		position: relative;
		background-color: #fff;
		border-radius: 12px;
	}

	.home_mei_right_li hgroup p {
		font-size: 14px;
		color: #808080;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 60000;
		margin-top: 10px;
		-webkit-line-clamp: 4;
		line-height: 24px;
		height: 96px;
	}

	.home_mei_right_li hgroup h6 {
		font-size: 14px;
		color: #333;
	}

	.home_mei_right_li hgroup {
		width: calc(100% - 70px);
		border-bottom: solid 1px #f5f5f5;
	}

	.home_mei_right_li:hover {
		opacity: 0.7;
	}

	.home_mei_right_li:nth-child(3n+3) {
		margin-right: 0;
	}

	.home_mei_right_li img {
		display: block;
		width: 60px;
		height: 60px;
		border-radius: 50px;
		overflow: hidden;
		object-fit: cover;
	}

	.home_mei_right li {
		width: 360px;
		padding: 20px 40px;
		border-radius: 10px;
		background-color: #fafafa;
		margin-top: 20px;
		margin-right: 20px;
		cursor: pointer;
	}

	.page {
		margin-top: 40px;
	}

	.more_fg img {
		display: block;
		width: 24px;
		height: 24px;
		margin-right: 10px;
	}

	.more_fg {
		margin-bottom: 15px;
	}

	.more_fg figcaption {
		font-size: 18px;
		color: #333;
		font-weight: bold;
	}
</style>
